// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "org.bitizen",
    name: "Bitizen",
    homepage: "https://bitizen.org/",
    image_id: "75dd1471-77e9-4811-ce57-ec8fc980ec00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/bitizen-defi-web3-eth-wallet/id1598283542",
        android: "https://play.google.com/store/apps/details?id=org.bitizen.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://bitizen.org/",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "bitizen://wallet/",
        universal: "https://bitizen.org/wallet/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map